export const sendRequestOfPaymentAdapter = (paymentPayload) => {
  return {
    transactionId: paymentPayload.uuid,
    clientId: paymentPayload.clientId,
    negotiationVariables: paymentPayload.details.negotiationVariables,
    status: paymentPayload.status,
    transactionType: {
      type: paymentPayload.details.type,
      cardNumber: paymentPayload.details.cardNumber,
      cardExpirationDate: paymentPayload.details.cardExpirationDate || null,
    },
  };
};

export const receiveResponseOfPaymentAdapter = (paymentResponse) => {
  const transaction = paymentResponse.transactions[0];
  return {
    uuid: transaction.uuid,
    clientId: transaction.clientId,
    status: paymentResponse.status,
    value: paymentResponse.value,
    details: {
      negotiationVariables: transaction.negotiationVariables,
      type: transaction.transactionType?.type,
      cardNumber: transaction.transactionType?.cardNumber,
      cardExpirationDate: transaction.transactionType?.cardExpirationDate || null,
    },
  };
};
